import { css } from '@emotion/react';
import { mediaQueries } from './viewHelpers';

const { tablet, mobile } = mediaQueries();

export const pcViewStyle = css`
  display: block;

  ${tablet(() => css`
    display: none;
  `)}
`;

export const tabletViewStyle = css`
  display: none;

  ${tablet(() => css`
    display: block;
  `)}

  ${mobile(() => css`
    display: none;
  `)}
`;

export const mobileViewStyle = css`
  display: none;

  ${mobile(() => css`
    display: block;
  `)}
`;

export const notPcViewStyle = css`
  display: none;

  ${tablet(() => css`
    display: block;
  `)}
`;

export const notTabletViewStyle = css`
  display: block;

  ${tablet(() => css`
    display: none;
  `)}

  ${mobile(() => css`
    display: block;
  `)}
`;

export const notMobileViewStyle = css`
  display: block;

  ${mobile(() => css`
    display: none;
  `)}
`;
